import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Importación añadida
import logo from '../data/inicio/logo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <Container className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <img
              src={logo}
              alt="Logo Academia Pixel"
              className="footer-logo"
            />
            <span>Academia Pixel</span>
          </div>
          
          <div className="footer-bottom">
            <p className="copyright">
              &copy; {new Date().getFullYear()} Todos los derechos reservados
            </p>
            <div className="footer-links">
              <Link to="/">Inicio</Link>
              <Link to="/contacto">Contacto</Link>
              <Link to="/terminos">Términos</Link>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;